import React, { useState } from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';

const InstructionLegend = (props: { className: string, id: string, title: string, bodyItems: Array<string> }) => {
    const [popoverOpen, setPopoverOpen] = useState(false);

    const onEnter = () => {
        setPopoverOpen(true);
    }

    const onExit = () => {
        setPopoverOpen(false);
    }

    return (
        <span>
            <Popover placement="auto" isOpen={popoverOpen} target={props.id}>
                <PopoverHeader className="text-center">{props.title}</PopoverHeader>
                <PopoverBody>
                    {props.bodyItems.map((item, index) => <p key={props.id + index}>{item}</p>)}
                </PopoverBody>
            </Popover>
            <span id={props.id} onMouseEnter={onEnter} onMouseLeave={onExit} className={`icon ${props.className}`}></span>

        </span>
    )
}

export default InstructionLegend;
